module.exports = __webpack_public_path__ + "static/dog-m-found-0d6126e56ab663a24cd3cceaf7d71ae0.jpg";